import { shareBasket } from '../service/api';
import { useApiCall } from 'modules/@common/hooks';

export function useBasketShare() {
  return useApiCall({ provider: shareBasket });
}
